import { Typography } from "@mui/material";

export const SectionHeader = ({ title }) => {
  return (
    <Typography variant="h4" fontWeight={500} mb={2}>
      {title}
    </Typography>
  );
};
